import React from "react";
import { Tag } from "antd";

interface ActionTypeTagProps {
  action: string;
}

const ActionTypeTag: React.FC<ActionTypeTagProps> = ({ action }) => {
  const getActionInfo = (action: string) => {
    const actionMap: Record<string, { text: string; color: string }> = {
      summary: { text: "摘要生成", color: "blue" },
      chat: { text: "普通对话", color: "green" },
      chat_kb_mcp: { text: "MCP对话", color: "purple" },
      chat_kb: { text: "知识库对话", color: "cyan" },
      hotword: { text: "热词生成", color: "orange" },
      search: { text: "向量搜索", color: "geekblue" },
      recharge: { text: "Token充值", color: "gold" },
      recommend: { text: "AI推荐", color: "volcano" },
    };

    return actionMap[action] || { text: action, color: "default" };
  };

  const { text, color } = getActionInfo(action);
  return <Tag color={color}>{text}</Tag>;
};

export default ActionTypeTag;
